import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { ItiScheduledTask } from '../../iti-core-vuetify';
import { ItiString, itiHttpService } from '@/iti-core-vue';
import ItiCoreAPI from '@/iti-core-vuetify/api/iti-core-api';
import { store } from '@/iti-core-vue/store';

@Module({
  namespaced: true,
  name: 'ItiScheduledTasksModule',
  store,
  dynamic: true,
})
class ItiScheduledTasksModule extends VuexModule {

  public tasks: ItiScheduledTask[] = [];
  public task: ItiScheduledTask = new ItiScheduledTask();

  @Action
  public async refreshTasks(): Promise<any> {
    const url = ItiString.Format(ItiCoreAPI.scheduledTasks);
    const res = await itiHttpService.get(url);
    this.context.commit('setTasks', res);
  }

  @Mutation
  public setTasks(tasks: ItiScheduledTask[]) {
    if (tasks != null) {
      this.tasks = tasks.map((x: ItiScheduledTask) => new ItiScheduledTask(x));
    }
  }

  @Mutation
  public setTaskInTasks(task: ItiScheduledTask) {
    const index = this.tasks.findIndex((x) => Number(x.id) === Number(task.id));
    if (index === -1) {
      this.tasks.push(task);
    } else {
      this.tasks = this.tasks.map((item) => item.id === task.id ? task : item);
    }
  }

  @Mutation
  public setTask(task: ItiScheduledTask) {
    this.task = task;
  }

  @Action
  public async saveTask() {
    let res: ItiScheduledTask;
    if (this.task.isNewItem()) {
      res = await itiHttpService.post(ItiCoreAPI.scheduledTasks, this.task.toJson());
    } else {
      res = await itiHttpService.put(ItiCoreAPI.scheduledTasks, this.task.toJson());
    }
    this.context.commit('setTaskInTasks', new ItiScheduledTask(res));
  }

  @Mutation
  public mutationDeleteTaskById(id: number) {
    this.tasks = this.tasks.filter((x) => x.id !== id);
  }

  @Action
  public async deleteTask(task: ItiScheduledTask) {
    const url = ItiString.Format(ItiCoreAPI.scheduledTask, task.id);
    const res: any = await itiHttpService.delete(url, task.toJson());
    this.context.commit('mutationDeleteTaskById', task.id);
  }

  @Action
  public async startTask(task: ItiScheduledTask) {
    const url = ItiString.Format(ItiCoreAPI.scheduledTaskStart, task.id);
    const res = await itiHttpService.put(url, task.toJson());
    this.context.commit('setTaskInTasks', new ItiScheduledTask(res));
  }

  @Action
  public async stopTask(task: ItiScheduledTask) {
    const url = ItiString.Format(ItiCoreAPI.scheduledTaskStop, task.id);
    const res = await itiHttpService.put(url, task.toJson());
    this.context.commit('setTaskInTasks', new ItiScheduledTask(res));
  }

}

export default getModule(ItiScheduledTasksModule);
